import React, { useState, useEffect } from 'react';
import BottomNav from './components/BottomNav';
import Home from './components/Home';
import MapView from './components/MapView';
import Web from './components/Web';
import Schedule from './components/Schedule';
import PdfViewer from './components/PdfViewer';
import './App.css';

function App() {
  const [value, setValue] = useState('home');
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    if (value === 'map' && !authenticated) {
      const entered = prompt('Enter password to access the map:');
      if (entered === 'u25r') {
        setAuthenticated(true);
      } else {
        alert('Incorrect password');
        setValue('home');
      }
    }
  }, [value, authenticated]);

  return (
    <div className="app-wrapper">
      <div className="app-container">
        <div className="content">
          {value === 'home' && <Home />}
          {value === 'map' && authenticated && <MapView />}
          {value === 'pdf' && <PdfViewer />}
          {value === 'schedule' && <Schedule />}
          {value === 'web' && <Web />}
        </div>
      </div>
      <BottomNav value={value} onChange={(event, newValue) => setValue(newValue)} />
    </div>
  );
}

export default App;
